import { Form } from "@sitecore-jss/sitecore-jss-react-forms";
import React from "react";
import { sitecoreApiHost, sitecoreApiKey } from "../../temp/config";
const SubscribeForm = ({ fields, navigate }) => (
  <Form
    form={fields}
    sitecoreApiHost={sitecoreApiHost}
    sitecoreApiKey={sitecoreApiKey}
    onRedirect={(url) => navigate(url)}
  />
);
export default SubscribeForm;
